import React from "react";
import { TableProps } from "./Types";
import { TableContainerView } from "./TableContainer.view";
import "./Style.scss";

interface TableContainerProps {
  /**
   * Text to be displayed if table is empty
   */
  emptyStateText: string;
  /**
   * Table data to be listed
   */
  table: TableProps;
  /**
   On Table row selection
   * @param e event object for the particular row selection
   */
  onRowSelected?: (e: React.MouseEvent<any>) => void;
}

export const TableContainer: React.FC<TableContainerProps> = (props: TableContainerProps) => {
  const { table, emptyStateText, onRowSelected } = props;
  return (
    <TableContainerView
      table={table}
      emptyStateText={emptyStateText}
      onRowSelected={onRowSelected}
    />
  );
};
